// $, Theme and Drupal Namespaces
// eslint-disable-next-line camelcase
const fds_theme = fds_theme || {};
const Drupal = Drupal || {};

// eslint-disable-next-line no-shadow
(($, Drupal) => {
  fds_theme.timelineHelper = (function() {
    const timelineHelper = {};

    timelineHelper.init = function(context) {
      $('.event-progress', context)
        .once('timelineHelper')
        .each(function() {
          const $this = $(this);
          const originalTitle = document.title;
          const $currentStep = $('.event-progress__step-number.active', $this);
          const currentStepTitle = $currentStep
            .siblings('.event-progress__step-name')
            .text();
          const currentStepTranslation = $currentStep
            .siblings('.visually-hidden')
            .last()
            .text();
          const currentStepNumber = $currentStep ? $currentStep.text() : null;
          if (currentStepNumber) {
            let titleParts = originalTitle.split('|');
            titleParts.splice(1, 0, ` ${currentStepTranslation} ${currentStepNumber} ${currentStepTitle} `);
            document.title = titleParts.join('|');
          }
        });
    };

    return timelineHelper;
  }());

  Drupal.behaviors.timelineHelper = {
    attach: (context, settings) => {
      fds_theme.timelineHelper.init(context, settings);
    },
  };

  // Init self in case we are loaded async.
  if ($.isReady) {
    /**
     * It is up to script to define scope and settings it should be applied to
     * in case of jquery mobile integration
     * used you can use site_common.jquery_mobile.getPageContext()
     * to get only current page's context.
     * In this implementation we use global scope.
     */
    const context = document;
    const { settings } = Drupal;
    Drupal.behaviors.timelineHelper.attach(context, settings);
  }
})(jQuery, Drupal);
